import { render } from 'solid-js/web';
import App from './App.jsx';
import UpdateBanner from './components/UpdateBanner.jsx';
import InstallPrompt from './components/InstallPrompt.jsx';
import { startUpdateChecks } from './lib/version.js';
import './styles/global.css';

render(() => (
  <>
    <App />
    <UpdateBanner />
    <InstallPrompt />
  </>
), document.getElementById('root'));

// Version check (auto-update on a different server version) — app-wide.
startUpdateChecks();
